import React from "react";

export const DRAWER_HEADER_STYLE = {
  display: "flex",
  alignItems: "center",
  gap: 8,
  minHeight: 52,
  padding: "8px 12px",
  boxSizing: "border-box",
  background:
    "linear-gradient(180deg, #875100 0%, #633b00 100%)",
  borderBottom: "1px solid rgba(255,178,46,.72)",
  boxShadow: "inset 0 1px 0 rgba(255,220,140,.18)",
  backdropFilter: "blur(10px) saturate(1.15)",
  WebkitBackdropFilter: "blur(10px) saturate(1.15)",
  color: "var(--color-text, #eaeaea)",
};

export const DRAWER_TITLE_STYLE = {
  flex: 1,
  fontSize: 14,
  fontWeight: 700,
  letterSpacing: 0.1,
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
};

export const DRAWER_ACTION_STYLE = {
  minHeight: 30,
  padding: "3px 12px",
  boxSizing: "border-box",
  borderRadius: 999,
  fontSize: 14,
  fontWeight: 600,
  lineHeight: 1.2,
};

export const DRAWER_ARROW_BUTTON_STYLE = {
  ...DRAWER_ACTION_STYLE,
  minWidth: 48,
  padding: "3px 10px",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
};

export function DrawerHeaderActions({ children }) {
  const normalize = (items) =>
    React.Children.map(items, (child) => {
      if (!React.isValidElement(child)) return child;
      if (child.type === React.Fragment) {
        return React.cloneElement(child, {}, normalize(child.props.children));
      }
      return React.cloneElement(child, {
        style: {
          ...(child.props.style || {}),
          ...DRAWER_ACTION_STYLE,
        },
      });
    });

  return (
    <div style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
      {normalize(children)}
    </div>
  );
}

export function DrawerArrowIcon({ direction = "right" }) {
  const points = direction === "left" ? "13 5 6 12 13 19" : "11 5 18 12 11 19";

  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      width="18"
      height="18"
      fill="none"
      focusable="false"
    >
      <path
        d={direction === "left" ? "M19 12H6" : "M5 12h13"}
        stroke="currentColor"
        strokeWidth="2.6"
        strokeLinecap="round"
      />
      <polyline
        points={points}
        stroke="currentColor"
        strokeWidth="2.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
